<template>
  <b-modal v-model="show" hide-footer no-close-on-backdrop hide-header-close>
    <div class="col-lg-12 text-center">
      <h4><b>Atenção!</b></h4>
      <br />
      <p>Pedidos do tipo Fulfillment, não serão impressos ou gerados.</p>
      <b-spinner variant="success"></b-spinner>
      <br />
      <br />
      <br />
    </div>
  </b-modal>
</template>

<script>
import barramento from "../../../../barramento";
export default {
  name: "AlerSpinner",
  props: ["expedition"],
  data() {
    return {
      show: false,
    };
  },
  beforeDestroy() {
    barramento.$off(`alert_spinner_${this.expedition}`);
  },
  created() {
    barramento.$on(`alert_spinner_${this.expedition}`, (show) => {
      this.show = show;
    });
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Orders_v2/Aggregates/ActionMenuDropdown/AlerSpinner.vue